import ModalHeaderProvider from './hooks/useModalHeader';

import { ModalHeaderProps } from './@types/ModalHeaderProps';
import IconClose from '../../icons/IconClose';
import { useHandleModal } from '../ModalTrigger/hooks/useHandleModal';

const ModalHeader = (props: ModalHeaderProps) => {
	const handleModal = useHandleModal();
	return (
		<ModalHeaderProvider {...props}>
			<div
				data-selection={props.componentId}
				className={`headerContainer ${props.blockClass ? `headerContainer--${props.blockClass} vtex-modal-layout-0-x-headerContainer--${props.blockClass}` : ''} vtex-modal-layout-0-x-headerContainer flex items-start bb b--muted-3 flex-shrink-0 flex-grow-0 z-5 justify-between`}
			>
				<div
					className={`headerContent ${props.blockClass ? `headerContent--${props.blockClass} vtex-modal-layout-0-x-headerContent--${props.blockClass}` : ''} vtex-modal-layout-0-x-headerContent`}
				>
					{props.children}
				</div>
				<div
					className={`closeButtonContainer ${props.blockClass ? `closeButtonContainer--${props.blockClass} vtex-modal-layout-0-x-closeButtonContainer--${props.blockClass}` : ''} vtex-modal-layout-0-x-closeButtonContainer`}
				>
					<button
						onClick={() => handleModal?.toggleModal()}
						className={`closeButton ${props.blockClass ? `closeButton--${props.blockClass} vtex-modal-layout-0-x-closeButton--${props.blockClass}` : ''} vtex-modal-layout-0-x-closeButton ma0 bg-transparent pointer bw0 pa3`}
					>
						<IconClose
							type={'line'}
							handle={`closeIcon vtex-modal-layout-0-x-closeIcon ${props.blockClass ? `closeIcon--${props.blockClass} vtex-modal-layout-0-x-closeIcon--${props.blockClass}` : ''}`}
							size={props.iconCloseSize}
						/>
					</button>
				</div>
			</div>
		</ModalHeaderProvider>
	);
};

export default ModalHeader;
